// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing);
  padding: var(--spacing);
  border-radius: var(--box-rounding);
  transition: var(--transition);
  width: 100%;
}

.app .title {
  font-size: 2rem;
  text-align: center;
  width: 100%;
  padding: var(--spacing);
  border: var(--border-size) var(--border-style) var(--border-color-alt);
  border-radius: var(--box-rounding);
  background-color: var(--background-alt);
  transition: var(--transition);
}

.app .content {
  display: flex;
  gap: var(--spacing);
  padding: var(--spacing);
  border: var(--border-size) var(--border-style) var(--border-color-alt);
  border-radius: var(--box-rounding);
  background-color: var(--background-alt);
  box-shadow: var(--box-shadow);
  transition: var(--transition);
  width: 100%;
  align-items: center;
}

@media (max-width: 1100px) {
  .app .content {
    flex-direction: column;
    padding: calc(var(--spacing) / 2);
    gap: calc(var(--spacing) / 2);
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ArtGrid/ArtGrid.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,sEAAsE;EACtE,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sEAAsE;EACtE,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;EAC7B,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,iCAAiC;IACjC,6BAA6B;IAC7B,WAAW;EACb;AACF","sourcesContent":[".app .container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing);\n  padding: var(--spacing);\n  border-radius: var(--box-rounding);\n  transition: var(--transition);\n  width: 100%;\n}\n\n.app .title {\n  font-size: 2rem;\n  text-align: center;\n  width: 100%;\n  padding: var(--spacing);\n  border: var(--border-size) var(--border-style) var(--border-color-alt);\n  border-radius: var(--box-rounding);\n  background-color: var(--background-alt);\n  transition: var(--transition);\n}\n\n.app .content {\n  display: flex;\n  gap: var(--spacing);\n  padding: var(--spacing);\n  border: var(--border-size) var(--border-style) var(--border-color-alt);\n  border-radius: var(--box-rounding);\n  background-color: var(--background-alt);\n  box-shadow: var(--box-shadow);\n  transition: var(--transition);\n  width: 100%;\n  align-items: center;\n}\n\n@media (max-width: 1100px) {\n  .app .content {\n    flex-direction: column;\n    padding: calc(var(--spacing) / 2);\n    gap: calc(var(--spacing) / 2);\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
